/* eslint-disable react/prop-types */
import React, {useState} from "react";

import {DivCarousel} from "./styles";
import {Swiper, SwiperSlide} from "swiper/react";
import {FreeMode, Navigation, Pagination, Thumbs} from "swiper";
import {City, ContainerCarousel, Img} from "./styles";
import jQuery from "jquery";

export const CarouselHotels = ({images}) => {

    const [thumbsSwiper, setThumbsSwiper] = useState(null);

    return(
        <DivCarousel>
            <Swiper
                style={{
                    "--swiper-navigation-color": "#fff",
                    "--swiper-pagination-color": "#fff",

                }}
                loop={true}
                spaceBetween={10}
                navigation={true}
                thumbs={{ swiper: thumbsSwiper }}
                modules={[FreeMode, Navigation, Thumbs]}
                className="mySwiper2"
            >
                {images.map((item,index) =>
                    <SwiperSlide key={index}>
                        <img src={item.url} />
                    </SwiperSlide>
                )}

            </Swiper>
            <Swiper
                onSwiper={setThumbsSwiper}
                loop={true}
                spaceBetween={10}
                slidesPerView={4}
                freeMode={true}
                watchSlidesProgress={true}
                modules={[FreeMode, Navigation, Thumbs]}
                className="mySwiper"
            >
                {images.map((item,index) =>
                    <SwiperSlide key={index} style={{height: "60px"}}>
                        <img src={item.url} />
                    </SwiperSlide>
                )}

            </Swiper>
        </DivCarousel>
    )
}

export const CarouselDefault = ({slidesPerView, images, className = 'nacional'}) => {

    const redirectPageAereo = (page) => {
        window.location.href = page;
    }

    let classNameSwiper = "mySwiper_" + className;

    return (
        <ContainerCarousel>
            <Swiper
                slidesPerView={slidesPerView}
                breakpoints={{
                    568: { slidesPerView: 2.5 },
                }}
                spaceBetween={30}
                pagination={{
                    clickable: true,
                }}
                modules={[Pagination]}
                className={`swiper-travel ${classNameSwiper}`}
                onSlideChange={(swiper) => {
                    let isEnd = swiper.isEnd;
                    if (isEnd) {
                        jQuery('.' + classNameSwiper).addClass('margin-left-minus-25');
                    } else {
                        jQuery('.' + classNameSwiper).removeClass('margin-left-minus-25');
                    }
                }}
            >
                {images.map((item) => {
                    const { uuid, title, image_url, url } = item;
                    return (
                        <SwiperSlide
                            key={uuid}
                            onClick={() => url !== '' ? redirectPageAereo(url) : null}
                        >
                            <Img src={image_url} alt={title} />
                            <City>{title}</City>
                        </SwiperSlide>
                    );
                })}
            </Swiper>
        </ContainerCarousel>
    )
}
